import { FC, useContext } from 'react'
import { ScreenContext } from 'react-components'

import { EventWidgetInputContainer } from './styles'
import DatePicker from '../../../../common/date-picker'
import DatePickerModal from '../../../../search-result-listing/header-section/searchbar/date-picker/modal'
import DatePickerWidget from '../../../../search-result-listing/header-section/searchbar/date-picker/widget'
import { DatePickerExclusiveProps, DatePickerMode, DatePickerProps } from '../../../../common/date-picker/types'
import { DatePickerModalCalendarContainer } from '../../../../search-result-listing/header-section/searchbar/date-picker/modal-styles'

type Props = Omit<DatePickerProps, keyof DatePickerExclusiveProps>

const EventDatePicker: FC<Props> = props => {
    const { isMobile } = useContext(ScreenContext)

    return (
        <EventWidgetInputContainer>
            <DatePicker
                mode={isMobile ? DatePickerMode.MODAL : DatePickerMode.WIDGET}
                modalComponent={DatePickerModal}
                widgetComponent={DatePickerWidget}
                modalCalendarContainerComponent={DatePickerModalCalendarContainer}
                {...props}
            />
        </EventWidgetInputContainer>
    )
}

export default EventDatePicker
